import { useCallback, useEffect, useState } from 'react';
import { DEFAULT_BILLING_CATALOG, type PublicBillingCatalog } from '../../../../../../shared/billing-catalog';
import {
  fetchPublicBillingCatalog,
  getPublicBillingCatalogCache,
  invalidatePublicBillingCatalogCache,
} from '../publicBillingCatalogService';

export function usePublicBillingCatalog(): {
  catalog: PublicBillingCatalog;
  loading: boolean;
  refresh: () => Promise<void>;
} {
  const [catalog, setCatalog] = useState<PublicBillingCatalog>(
    getPublicBillingCatalogCache() ?? DEFAULT_BILLING_CATALOG,
  );
  const [loading, setLoading] = useState(!getPublicBillingCatalogCache());

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      invalidatePublicBillingCatalogCache();
      const next = await fetchPublicBillingCatalog();
      setCatalog(next);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (getPublicBillingCatalogCache()) return;
    let cancelled = false;
    void fetchPublicBillingCatalog().then((next) => {
      if (!cancelled) {
        setCatalog(next);
        setLoading(false);
      }
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return { catalog, loading, refresh };
}
